var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalPolicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 60,
    rx: 5,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 41,
    width: 16.917,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47,
    width: 11.518,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.653 13.178a4.378 4.378 0 00-6.187 0l-5.12 5.12a4.378 4.378 0 000 6.187 4.378 4.378 0 006.188 0l5.12-5.12a4.378 4.378 0 000-6.187zm-8.04 4.328a.897.897 0 01.7-.26c.523.087 1.431.312 2.196 1.077.768.768.986 1.687 1.046 2.215a.877.877 0 01-.255.675c-.431.462-1.3 1.331-1.3 1.331l-.703.704a2.626 2.626 0 01-3.713-3.713l1.213-1.212.816-.817z",
    fill: "#333"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA1MCA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjYwIiByeD0iNSIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iOCIgeT0iMzUiIHdpZHRoPSIyMiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzJDMkQyRSIvPgo8cmVjdCB4PSI4IiB5PSI0MSIgd2lkdGg9IjE2LjkxNjciIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyQzJEMkUiLz4KPHJlY3QgeD0iOCIgeT0iNDciIHdpZHRoPSIxMS41MTg0IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzAuNjUzNCAxMy4xNzg0QzI4Ljk0NjMgMTEuNDcxMyAyNi4xNzM0IDExLjQ3MTMgMjQuNDY2MyAxMy4xNzg0TDE5LjM0NjYgMTguMjk4QzE3LjYzOTUgMjAuMDA1MiAxNy42Mzk1IDIyLjc3OCAxOS4zNDY2IDI0LjQ4NTJDMjEuMDUzOCAyNi4xOTIzIDIzLjgyNjYgMjYuMTkyMyAyNS41MzM4IDI0LjQ4NTJMMzAuNjUzNCAxOS4zNjU1QzMyLjM2MDUgMTcuNjU4NCAzMi4zNjA1IDE0Ljg4NTUgMzAuNjUzNCAxMy4xNzg0Wk0yMi42MTMgMTcuNTA2MkMyMi43OTc2IDE3LjMyMTUgMjMuMDUzMSAxNy4yMjYyIDIzLjMxMyAxNy4yNDU0QzIzLjgzNjMgMTcuMzMyOSAyNC43NDQ1IDE3LjU1NzggMjUuNTA5MyAxOC4zMjI1QzI2LjI3NzUgMTkuMDkwOCAyNi40OTU0IDIwLjAxMDQgMjYuNTU0OSAyMC41MzhDMjYuNTcwNiAyMC43ODkyIDI2LjQ3NzkgMjEuMDM1IDI2LjMwMDMgMjEuMjEyN0MyNS44Njg5IDIxLjY3NDcgMjUgMjIuNTQ0NCAyNSAyMi41NDQ0TDI0LjI5NjUgMjMuMjQ3OUMyMy4yNzE5IDI0LjI3MjUgMjEuNjA4NSAyNC4yNzI1IDIwLjU4MzkgMjMuMjQ3OUMxOS41NTkzIDIyLjIyMzMgMTkuNTU5MyAyMC41NTk5IDIwLjU4MzkgMTkuNTM1M0wyMS43OTY2IDE4LjMyMjVDMjEuNzk2NiAxOC4zMjI1IDIyLjI5MzYgMTcuODI1NSAyMi42MTMgMTcuNTA2MloiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg==";
export { SvgMedicalPolicy as ReactComponent };